<a
  [routerLink]="'/' + link()"
  class="nav-link transition-all group flex flex-row items-center no-underline"
  routerLinkActive="active"
  [title]="displayName()"
>
  <div class="nav-link__icon-wrap flex-initial flex flex-row items-center transition-all">
    <mat-icon class="icon" [svgIcon]="icon()"></mat-icon>
  </div>
  <div class="display-name flex-auto no-underline transition-all">
    <strong>{{ displayName() }}</strong>
  </div>
</a>
